import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {IRefreshable} from './central-management-app.model';


@Component({
    host: {
        '(document:keyup)': '_keyup($event)',
        '(document:keydown)': '_keydown($event)',
    },
    selector: 'central-management-app',
    templateUrl: './central-management-app.html'
})



export class CentralManagementAppComponent implements OnInit {


    public routedComponent: IRefreshable;

    public resources = {
        imgs: {
            CM: "./assets/images/RIS_CM.png"
        }
    };

    private _keydown(event: KeyboardEvent) {
        if (event.keyCode === 116) {
            event.preventDefault();

            this.refresh();
        }
    }



    private _keyup(event: KeyboardEvent) {
        //if (event.keyCode === 116) {
        //    event.preventDefault();
            //alert('/' + this.selectedTab);
            //this.router.navigate(['/ris-clients-state']);
        //}
        //else alert('no 116');
        //    else if (event.keyCode === 13) ...;
        //else if (event.keyCode === 37) ...;
        //else if (event.keyCode === 38) ...;
        //else if (event.keyCode === 39) ...;
        //else if (event.keyCode === 40) ...;

        // else console.log(event.keyCode);
    }

    private selectedTab: string;
    //todos: Array<Object>;

    constructor(private route: ActivatedRoute) {
        //this.todos = [{ text: "Try Second", done: true }]
        //this.selectedTab = '/ris-clients-state';


    }

    ngOnInit() {
        //this.router.navigate(['/ris-servers-state']);
    }

    private refresh()
    {
        this.routedComponent.refresh();
    }
}
